import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { DirectDebitMandateCountsQueryDocument } from './directDebitMandateCountsQuery.gql';

interface Count {
  totalCount: number;
}

interface DirectDebitMandateCountsQueryData {
  viewer: {
    activeCount: Count;
    suspendedCount: Count;
  };
}

interface DirectDebitMandateCountsResult {
  activeCount?: number;
  suspendedCount?: number;
}

export const useDirectDebitMandateCountsQuery =
  (): DirectDebitMandateCountsResult => {
    const { companyProfileId } = useCompanyContext();
    const { data } = useQuery<DirectDebitMandateCountsQueryData>(
      DirectDebitMandateCountsQueryDocument,
      {
        fetchPolicy: 'cache-and-network',
        skip: !companyProfileId,
        variables: { companyProfileId },
      },
    );

    const activeCount = data?.viewer?.activeCount?.totalCount;
    const suspendedCount = data?.viewer?.suspendedCount?.totalCount;

    // In case the query fails, we do not want to block the screen
    // so there is no need to handle loading or error state
    return {
      activeCount,
      suspendedCount,
    };
  };

interface RefetchQueryArgs {
  companyProfileId: string;
}

export function refetchQueryDirectDebitMandateCounts({
  companyProfileId,
}: RefetchQueryArgs) {
  return {
    query: DirectDebitMandateCountsQueryDocument,
    variables: { companyProfileId },
  };
}
